<template>
  <div>
    <div class="text-center depahead rsu">ยืนยันตัวตน</div>
    <div style="max-width: 500px; margin-left: auto; margin-right: auto">
      <div style="height: 60px; padding-top: 10px">
        <v-img style="margin-left: auto; margin-right: auto" width="80px" src="../../assets/depa.png"></v-img>
      </div>
      <v-container>
        <ValidationObserver ref="observer">
          <div>
            <div class="mb-6" style="font-weight: 600; font-size: 22px">
              ยืนยันตัวตน
            </div>
            <div>
              <ValidationProvider name="รูปโปรไฟล์" :key="'รูปโปรไฟล์'" :rules="{ required: false }" v-slot="{ errors }">
                <upload-profile :errors="errors" v-model="input.profile_pic" :height="120"></upload-profile>
              </ValidationProvider>
            </div>
            <div>
              <div style="color: grey">ชื่อหน่วยงาน</div>
              <ValidationProvider name="ชื่อหน่วยงาน" :key="'ชื่อหน่วยงาน'" :rules="{ required: true }" v-slot="{ errors }">
                <v-text-field :error-messages="errors" v-model="input.institute_name" outlined dense></v-text-field>
              </ValidationProvider>
            </div>
            <div>
              <div style="color: grey">ชื่อผู้ประสานงาน</div>
              <ValidationProvider name="ชื่อผู้ประสานงาน" :key="'ชื่อผู้ประสานงาน'" :rules="{ required: true }" v-slot="{ errors }">
                <v-text-field v-model="input.coordinator_name" :error-messages="errors" outlined dense></v-text-field>
              </ValidationProvider>
            </div>
            <template v-if="$store.state.input.membertype == 'มหาวิทยาลัย'">
              <div>
                <div style="color: grey">ชื่อคณะ</div>
                <ValidationProvider name="ชื่อคณะ" :key="'ชื่อคณะ'" :rules="{ required: true }" v-slot="{ errors }">
                  <v-text-field v-model="input.faculty" :error-messages="errors" outlined dense></v-text-field>
                </ValidationProvider>
              </div>
              <div>
                <div style="color: grey">รหัสคณะ</div>
                <ValidationProvider name="รหัสคณะ" :key="'รหัสคณะ'" :rules="{ required: true }" v-slot="{ errors }">
                  <v-text-field v-model="input.faculty_id" :error-messages="errors" outlined dense></v-text-field>
                </ValidationProvider>
              </div>
            </template>
            <!-- <div v-if="documentList && documentList.length">
              <v-layout justify-space-between v-if="documentList && documentList.length">
                <div style="color: grey">อัปโหลดเอกสาร</div>
                <span @click="showDoc = true" style="color: blue; cursor: pointer;margin-bottom: 5px;text-decoration: underline;">รายการเอกสารที่ต้องอัปโหลด</span>
              </v-layout>
              <div style="display: flex; flex-direction: row"> -->
                <!-- <div class="px-2">
              <v-icon size="35">mdi-upload</v-icon>
            </div> -->
                <!-- <div style="width: 100%">
                  <ValidationProvider name="เอกสาร" :key="'เอกสาร'" :rules="{ required: true }" v-slot="{ errors }">
                    <UploadDocument :errors="errors" v-model="input.document"></UploadDocument>
                  </ValidationProvider>
                </div>
              </div>
              <input style="height: 0px; width: 0px; visibility: hidden" type="file" ref="fileuploadinput" />
            </div> -->
          </div>
        </ValidationObserver>
        <div class="flex-all-center mb-4">
          <v-flex xs12>
            <v-btn :loading="loading" @click="saveDraft" class="text-capitalize w-max" block>Save Draft</v-btn>
          </v-flex>
        </div>
        <v-layout row justify-space-between>
          <v-flex class="submitbtn">
            <v-btn :loading="loading" @click="back" class="text-capitalize w-max" block>Back</v-btn>
          </v-flex>
          <v-flex class="submitbtn">
            <v-btn :loading="loading" depressed @click="verify" class="text-capitalize" color="primary" block>Confirm</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
      <!-- <v-dialog v-model="showDoc" scrollable persistent max-width="500px" transition="dialog-transition">
        <v-card>
          <div class="text-right">
            <v-btn @click="showDoc = false" icon><v-icon>close</v-icon> </v-btn>
          </div>
          <div class="pa-5">
            <h5>รายการเอกสารที่ต้องอัปโหลด</h5>
            <div v-for="(item, index) in documentList" :key="`doc-list-${index}`">{{ index + 1 }}. {{ item }}</div>
          </div>
        </v-card>
      </v-dialog> -->
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import UploadProfile from "../../components/UploadProfile.vue";
// import UploadDocument from "../../components/UploadDocumentProfile.vue";
export default {
  components: {
    UploadProfile,
    // UploadDocument,
  },
  data() {
    return {
      // showDoc: false,
      loading: false,
      input: {
        profile_pic: "",
        institute_name: "",
        coordinator_name: "",
        document: "",
        faculty: "",
        faculty_id: "",
      },
      inputfile: "",
    };
  },
  computed: {
    selectType() {
      return this.$store.state.input;
    },
    // documentList() {
    //   return this.selectType.document ? this.selectType.document.split(",") : [];
    // },
    dataD() {
      return this.$store.state.profiledata;
    },
  },
  mounted() {
    let draft = Vue.localStorage.get("regisDataNoTax");
    draft = draft ? JSON.parse(draft) : null;
    if (draft) {
      this.input = draft;
    } else if (this.dataD && this.dataD.institute_name) {
      this.input = {
        profile_pic: this.dataD.profile_pic,
        institute_name: this.dataD.institute_name,
        coordinator_name: this.dataD.coordinator_name,
        // document: this.dataD.document,
        faculty: this.dataD.faculty,
        faculty_id: this.dataD.faculty_id,
      };
    }
  },
  methods: {
    back() {
      this.query.view = "Verifyinfo";
    },
    async verify() {
      if (await this.$refs.observer.validate()) {
        this.loading = true;
        var data = {
          ...this.$store.state.profiledata,
          ...this.input,
          memberid: this.$store.state.memberid,
        };

        var status = await this.$store.dispatch("depamemberinfo_verification", data);
        if (status == 200) {
          Vue.localStorage.remove("regisDataNoTax");
          await this.$liff.closeWindow();
        }
        this.loading = false;
      }
    },
    async saveDraft() {
      this.loading = true;
      let body = {
        ...this.input,
      };

      try {
        Vue.localStorage.set("regisDataNoTax", JSON.stringify(body));
        this.loading = false;
        await this.$swal.fire({
          icon: "success",
          text: "บันทึกสำเร็จ",
        });
      } catch (error) {
        await this.$swal.fire({
          icon: "error",
          text: "บันทึกไม่สำเร็จ",
        });
      }
    },
  },
};
</script>

<style lang="scss"></style>
